import React from 'react';
import { useTranslation } from 'react-i18next';
import './PendingPaymentBanner.scss';

const PendingPaymentBanner = ({ subscriptionUrl }) => {
    const { t } = useTranslation();

    return (
        <div className="pending-payment-banner">
            <div className="pending-payment-banner__icon-area">
                <div className="pending-payment-banner__icon-circle">
                    <i className="fa fa-clock"></i>
                </div>
            </div>
            <div className="pending-payment-banner__content">
                <h6 className="pending-payment-banner__title">
                    {t('agency_subscription.pending_payment_title')}
                </h6>
                <p className="pending-payment-banner__description">
                    {t('agency_subscription.pending_payment_description')}
                </p>
                {subscriptionUrl ? (
                    <div className="pending-payment-banner__actions">
                        <a
                            href={subscriptionUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn -alt pending-payment-banner__cta"
                        >
                            <i className="fa fa-credit-card"></i>
                            {t('agency_subscription.pending_payment_pay_now')}
                        </a>
                        <span className="pending-payment-banner__hint">
                            <i className="fa fa-envelope"></i>
                            {t('agency_subscription.pending_payment_email_sent')}
                        </span>
                    </div>
                ) : (
                    <p className="pending-payment-banner__hint">
                        <i className="fa fa-envelope"></i>
                        {t('agency_subscription.pending_payment_no_link')}
                    </p>
                )}
            </div>
        </div>
    );
};

export default PendingPaymentBanner;
